// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wIL4","toggle":"styles_toggle__3C8ZX","preview":"styles_preview__2xUcH"};